import { fetchConfig, debounce, Animations } from '@lib/section-utils';
import { openDrawer, closeDrawer, overflowAdd, overflowRemove, trapFocus } from '@lib/pubsub';

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.section = this.closest('[data-main-collection-wrapper]');
    

    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.drawer = document.querySelector('[data-drawer="filters"]');
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 600);
    
    const facetForm = this.querySelector('form');
    this.filterType = facetForm.getAttribute('data-type');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
    document.body.appendChild(document.querySelector('filter-drawer'));
    
    // Store the keyup handler reference for proper cleanup
    this.keyupHandler = this.handleKeyup.bind(this);
    
    // Only add keyup listener for desktop filters (FacetFiltersForm), not mobile (FacetFiltersFormMobile)
    if (facetForm.id === 'FacetFiltersForm') {
      document.addEventListener('keyup', this.keyupHandler);
    }

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');

    this.querySelectorAll('details[data-js-filter]').forEach((filter) => {
      filter.addEventListener('toggle', (event) => {
        if (filter.open) {
          this.closeOtherFilters(filter);
        }
      });
    });

    // Close filter UI after applying filters
    document.addEventListener('click', (e) => {
      const applyBtn = e.target.closest('[data-apply-filters]');
      if (!applyBtn) return;

      // Submit the filters form
      const form =
        applyBtn.closest('facet-filters-form')?.querySelector('form') ||
        applyBtn.closest('form');

      if (form) {
        const submitted = form.dispatchEvent(
          new Event('submit', { bubbles: true, cancelable: true })
        );
        if (!submitted && typeof form.submit === 'function') form.submit();
      }

      // Close filters
      this.closeFiltersUI();
    });

    // Close any open filter on outside click - but only for filter details, not the entire filter container
    // document.addEventListener('click', this.handleOutsideClick.bind(this));

    const togglemObileFilters = (selectors, action) => {
      selectors.forEach(selector => {
        const trigger = document.querySelector(selector);
        if (trigger) {
          trigger.addEventListener('click', () => {
            const filtersContainer = document.querySelector('filter-drawer');
            if (filtersContainer) {
              if (action === 'add') {
                filtersContainer.classList.add('offcanvas-open', 'filters-open');
                overflowAdd();

                this.showApplyButton();
              } else if (action === 'remove') {
                filtersContainer.classList.remove('offcanvas-open', 'filters-open');
                overflowRemove();
                // Only add `filters-closed` for mobile-specific hide triggers
                if (selector === '[data-filters-mobile-hide]') {
                  filtersContainer.classList.add('offcanvas-close', 'filters-closed');
                  overflowRemove();
                }
              }
            }
          });
        }
      });
    };

    const toggleFilters = (selectors, action) => {
      selectors.forEach(selector => {
        const trigger = document.querySelector(selector);
        if (trigger) {
          trigger.addEventListener('click', () => {
            const filtersContainer = document.querySelector('[data-filters-style]');
            if (filtersContainer) {
              if (action === 'add') {
                filtersContainer.classList.add('filters-open');
                filtersContainer.classList.remove('filters-closed');

                // Ensure apply button is visible when filters are open
                this.showApplyButton();
              } else if (action === 'remove') {
                filtersContainer.classList.remove('filters-open');
              }
            }
          });
        }
      });
    };

    const handleResponsiveFilter = () => {
      const filtersContainer = document.querySelector('[data-filters-style]');
      if (filtersContainer && window.innerWidth <= 767) {
        filtersContainer.classList.remove('filters-open');
        filtersContainer.classList.add('filters-closed');
      } else {
        filtersContainer.classList.add('filters-open');
        filtersContainer.classList.remove('filters-closed');
      }
    };

    ['DOMContentLoaded', 'resize'].forEach(evt =>
      window.addEventListener(evt, handleResponsiveFilter)
    );

    toggleFilters(['[data-filters-show]'], 'add');
    toggleFilters(['[data-filters-hide]'], 'remove');

    if(this.filterType == 'drawer'){
      console.log('drawer exists',this.filterType);
        document.getElementById('main-collection-filters').innerHTML = ''; // check this code tommorow
        document.body.appendChild(this.drawer);
        if(document.querySelector('[data-filters-drawer]')){
          document.addEventListener('click', (e) => {
            const button = e.target.closest('[data-filters-drawer]');
            if (!button) return;
            e.preventDefault();
            this.open();
          });
        }

      this.drawer.querySelectorAll('[data-offcanvas-close], [offcanvas-close]').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          this.close();
        });
      });
      document.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      window.addEventListener('resize', () => this.toggleDrawerResize());
    }
    // toggleFilters(['[data-filters-show-drawer]'], 'add');
    togglemObileFilters(['[data-filters-mobile-show]'], 'add');
    togglemObileFilters(['[data-filters-mobile-hide]'], 'remove');
  }
  connectedCallback() {
     this.mobileStickyFilter();
     if (this.filterType == 'horizontal') {
      this.horizontalFilterPositions();
      window.addEventListener('resize', this.horizontalFilterPositions.bind(this));
    }
  }
   
  mobileStickyFilter() {
    if (!this.section) return;

    // 1️⃣ Check if attribute exists INSIDE section
    this.mobileStickyEl = this.section.querySelector('[data-filter-mobile-sticky]');
    if (!this.mobileStickyEl) return;

    // Target element where class will be added
    this.filterBar = this.section.querySelector('[data-filters-style]');
    if (!this.filterBar) return;

    const onScroll = () => {
      const rect = this.section.getBoundingClientRect();
      const vh = window.innerHeight;

      /*
        ADD when section enters from bottom (100px)
        REMOVE when section bottom touches bottom (start exiting)
      */

      const addSticky = rect.top <= vh - 100;
      const removeSticky = rect.bottom <= vh;

      if (addSticky && !removeSticky) {
        this.filterBar.classList.add('sticky-filter-show');
      } else {
        this.filterBar.classList.remove('sticky-filter-show');
      }
    };


    // Run once initially
    onScroll();

    window.addEventListener('scroll', onScroll, { passive: true });
  }

  toggleDrawerResize(){
    const isMobile = window.innerWidth < 768;
    if(isMobile){
      this.close();
    }
  }
  open() {

    openDrawer('filters');
    overflowAdd();
    if (this.drawer) {
      setTimeout(() => {
        trapFocus(this.drawer);
      }, 500);
    }
  }

  close() {
    closeDrawer('filters');
    overflowRemove();
    const getLastClickedElement = document.querySelector('.click-focus-element');
    if(getLastClickedElement){
      getLastClickedElement.focus();
      getLastClickedElement.classList.remove('click-focus-element');
    }
  }

  horizontalFilterPositions() {
    const windowSize = window.innerWidth;
    this.querySelectorAll('details[data-js-filter]').forEach((el) => {
      el.classList.remove('open-filter-left');
      // el.style.removeProperty('--dropdown-parent--width');
    });
    this.querySelectorAll('details[data-js-filter]').forEach((filter) => {

      const rect = filter.querySelector('.collapsible-content').getBoundingClientRect();

      let currentPosition = rect.left + rect.width;
      if (currentPosition >= windowSize) {
        filter.classList.add('open-filter-left');
      }
    });
  }

  handleKeyup(e) {
    if (e.key === 'Enter') {
      // Check if the event is coming from mobile filter drawer
      const isFromMobileDrawer = e.target.closest('filter-drawer');
      if (isFromMobileDrawer) {
        return; // Don't handle keyup events from mobile filter drawer
      }
      
      const icon = e.target.closest('.checkbox-styled-icon[role="checkbox"]');
      if (icon) {
        e.preventDefault();
        const label = icon.closest('label');
        const inputId = label?.getAttribute('for');
        const input = inputId ? document.getElementById(inputId) : label?.querySelector('input[type="checkbox"], input[type="radio"]');
        if (input && !input.disabled) {
          input.checked = !input.checked;
          icon.setAttribute('aria-checked', input.checked ? 'true' : 'false');
          input.dispatchEvent(new Event('input', { bubbles: true }));
          // input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }
  }

  disconnectCallback() {
    this.removeEventListener('input', this.debouncedOnSubmit.bind(this));
    // Only remove keyup listener if it was added (for desktop filters)
    const facetForm = this.querySelector('form');
    if (facetForm && facetForm.id === 'FacetFiltersForm' && this.keyupHandler) {
      document.removeEventListener('keyup', this.keyupHandler);
    }
  }

  closeOtherFilters(currentOpenFilter) {
    this.querySelectorAll('details[data-js-filter]').forEach((filter) => {
      if (filter !== currentOpenFilter && filter.open) {
        filter.open = false;
      }
    });
  }


  handleOutsideClick(event) {
    // Only close filter details if clicking outside of them, not the entire filter container
    const isClickInsideFilterDetails = event.target.closest('details[data-js-filter]');
    const isClickInsideFilterContainer = event.target.closest('[data-filters-style]');
    const isClickInsideFilterDrawerContainer = event.target.closest('filter-drawer');
    const isClickOnFilterToggle = event.target.closest('[data-filters-show], [data-filters-hide], [data-filters-mobile-show], [data-filters-mobile-hide]');

    // If clicking on filter toggle buttons, don't close anything
    if (isClickOnFilterToggle) {
      return;
    }

    // If clicking inside filter container but outside filter details, don't close anything
    if (isClickInsideFilterContainer && !isClickInsideFilterDetails) {
      return;
    }
    if (isClickInsideFilterDrawerContainer && !isClickInsideFilterDetails) {
      return;
    }

    // Only close filter details if clicking completely outside the filter system
    if (!isClickInsideFilterContainer) {
      this.querySelectorAll('details[data-js-filter]').forEach((filter) => {
        if (filter.open) {
          filter.open = false;
        }
      });
    }
  }

  showApplyButton() {
    // Show apply button when filters are open
    const applyButtons = document.querySelectorAll('[data-apply-filters]');
    applyButtons.forEach(btn => {
      btn.style.display = 'block';
      btn.style.visibility = 'visible';
      btn.style.opacity = '1';
    });
  }

  hideApplyButton() {
    // Hide apply button when filters are closed
    const applyButtons = document.querySelectorAll('[data-apply-filters]');
    applyButtons.forEach(btn => {
      btn.style.display = 'none';
      btn.style.visibility = 'hidden';
      btn.style.opacity = '0';
    });
  }

  closeFiltersUI() {
    // Close all open filter details
    this.querySelectorAll('details[data-js-filter]').forEach((filter) => {
      if (filter.open) {
        filter.open = false;
      }
    });


    // Close mobile filters if they're open
    const filtersContainer = document.querySelector('filter-drawer');
    if (filtersContainer) {
      filtersContainer.classList.remove('filters-open', 'offcanvas-open');
      overflowRemove();
    }

    // Hide apply button
    this.hideApplyButton();
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    console.log('render page');
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');

    // document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    // if (countContainer) {
    //   countContainer.classList.add('loading');
    // }
    // if (countContainerDesktop) {
    //   countContainerDesktop.classList.add('loading');
    // }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);

    Animations.initAll();
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    const container = document.getElementById('ProductGridContainer');
    const filtersContainer = document.querySelector('[data-filters-style]');

    container.innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;

    container.querySelectorAll('[data-collection-item]').forEach((element) => {
      element.classList.add('scroll-trigger--cancel');
    });

    // 👇 scroll to container after render
    filtersContainer.scrollIntoView({
      behavior: 'smooth',  // smooth scrolling
      block: 'start'       // align to top
    });
    Animations.initAll();
  }


  static renderProductCount(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const countElement = parsedHTML.getElementById('ProductCount');
    if (!countElement) return;

    const count = countElement.innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');

    if (container) {
      container.innerHTML = count;
      container.classList.remove('loading');
    }
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm [data-js-filter], #FacetFiltersFormMobile [data-js-filter], #FacetFiltersPillsForm [data-js-filter]'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm [data-js-filter], #FacetFiltersFormMobile [data-js-filter], #FacetFiltersPillsForm [data-js-filter]'
    );

    // Remove filters that are no longer returned from the server
    // Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
    //   if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
    //     currentElement.remove();
    //   }
    // });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('[data-js-filter]') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const filtersToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    filtersToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = filtersToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} [data-js-filter]`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('[data-js-filter]').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('[data-js-filter]'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-filters__details')
          ? `.mobile-filters__close-button`
          : `.filters__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-filters', '.active-filtermob'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['filter-drawer'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    // document.getElementById('FacetFiltersFormMobile').closest('filter-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.filters__summary');
    const sourceSummary = source.querySelector('.filters__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.filters__header');
    const sourceHeaderElement = source.querySelector('.filters__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.filters-wrap');
    const sourceWrapElement = source.querySelector('.filters-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.filters__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-filters__list');
    const sourceFacetsList = source.querySelector('.mobile-filters__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
    if (window.innerWidth < 1024) return;
    // document.querySelectorAll('details[data-js-filter]').forEach((filter) => {
    //   if (filter.open) {
    //     filter.open = false;
    //   }
    // });
  }

  static getSections() {
    return [
      {
        section: document.querySelector('[data-product-grid]').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    const filtersContainer = document.querySelector('filter-drawer');
    if (event.srcElement.className == 'mobile-facets-checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
          this.showApplyButton();

          if (isMobile && event.target.matches('select[name="sort_by"]')) {
            // ✅ Mobile + select: close filters
            filtersContainer.classList.remove('filters-open', 'offcanvas-open');
            overflowRemove();
          }
        }
      });
      this.onSubmitForm(forms.join('&'), event);


    }
  }


  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);

customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRangeFilters extends HTMLElement {
  constructor() {
    super();

    if (!this.querySelector('[data-range-bars]')) return;

    this.rangeBars = this.querySelectorAll('input[type=range]');
    this.numberFields = this.querySelectorAll('input[type=number]');
    this.progress = this.querySelector('[data-filter-progress]');

    this.thumbsGap = 1;

    this.rangeBars.forEach((rangeBar) => {
      rangeBar.addEventListener('input', this.rangeBarHandle.bind(this));
    });

    this.numberFields.forEach((numberField) => {
      numberField.addEventListener('input', this.numberFieldHandle.bind(this));
    });

    this.setrangeBarHandle();

  }
  setrangeBarHandle(event) {
    this.rangeBars.forEach((el) => {
      let minVal = parseInt(this.rangeBars[0].value),
        maxVal = parseInt(this.rangeBars[1].value);

      const maxRange = parseFloat(this.rangeBars[1].max);

      const maxPercent = (maxVal / maxRange) * 100;

      const invertedMaxPercent = 100 - maxPercent;

      this.progress.style.setProperty('--range-min', (minVal / this.rangeBars[0].max) * 100 + '%');
      this.progress.style.setProperty('--range-max', maxPercent + '%');

    });
  }


  rangeBarHandle(event) {
    this.rangeBars.forEach((el) => {
      let minVal = parseInt(this.rangeBars[0].value),
        maxVal = parseInt(this.rangeBars[1].value);

      if (maxVal - minVal < this.thumbsGap) {

        this.rangeBars[0].value = maxVal - this.thumbsGap;

        this.rangeBars[1].value = minVal + this.thumbsGap;

      } else {
        this.numberFields[0].value = minVal;
        this.numberFields[1].value = maxVal;
        const maxRange = parseFloat(this.rangeBars[1].max);

        const maxPercent = (maxVal / maxRange) * 100;

        const invertedMaxPercent = 100 - maxPercent;

        this.progress.style.setProperty('--range-min', (minVal / this.rangeBars[0].max) * 100 + '%');
        this.progress.style.setProperty('--range-max', maxPercent + '%');
      }
    });
  }

  numberFieldHandle(event) {
    this.numberFields.forEach((el) => {
      let minPrice = parseFloat(this.numberFields[0].value),
        maxPrice = parseFloat(this.numberFields[1].value);

      if (maxPrice - minPrice >= this.thumbsGap && maxPrice <= this.rangeBars[1].max) {

        this.rangeBars[0].value = minPrice;

        this.progress.style.setProperty('--range-min', (minPrice / this.rangeBars[0].max) * 100 + '%');

        this.rangeBars[1].value = maxPrice;
        const maxRange = parseFloat(this.rangeBars[1].max);
        const maxPercent = (maxPrice / maxRange) * 100;

        this.progress.style.setProperty('--range-max', maxPercent + '%');
      }
    });
  }
}

customElements.define('price-range', PriceRangeFilters);


class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

if (!customElements.get('filter-drawer')) {
  customElements.define(
    'filter-drawer',
    class FilterDrawer extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        window.addEventListener('resize', () => this.toggleMobileDrawerResize());
        const closeButtons = [
          this.querySelector('[data-offcanvas-close]'),
          this.querySelector('[offcanvas-close]')
        ];

        closeButtons.forEach((btn) => {
          if (btn) {
            btn.addEventListener('click', (e) => {
              e.preventDefault();
              this.hide();
            });
          }
        });
      }
      toggleMobileDrawerResize(){
        const isDesktop = window.innerWidth > 767;
        if(isDesktop){
          this.hide();
        } 
      }
      
      hide() {
        this.classList.remove('offcanvas-open', 'filters-open');
        this.removeAttribute('open');
        overflowRemove();
      }

      show(focusElement) {
        this.focusElement = focusElement;
        this.setAttribute('open', '');
        this.classList.add('offcanvas-open', 'filters-open');
        overflowAdd();

      }
    }
  );
}

